var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMyIbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2701_162899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2701_162899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9038 19.5C16.6478 19.5 16.4331 19.4133 16.2598 19.24C16.0866 19.0668 16 18.8522 16 18.596V14.5C16 14.244 16.0866 14.0293 16.2598 13.856C16.4331 13.6828 16.6478 13.5963 16.9038 13.5963H18.596C18.8522 13.5963 19.0668 13.6828 19.24 13.856C19.4133 14.0293 19.5 14.244 19.5 14.5V18.596C19.5 18.8522 19.4133 19.0668 19.24 19.24C19.0668 19.4133 18.8522 19.5 18.596 19.5H16.9038ZM11.1537 19.5C10.8977 19.5 10.6831 19.4133 10.5098 19.24C10.3366 19.0668 10.25 18.8522 10.25 18.596V5.404C10.25 5.14783 10.3366 4.93317 10.5098 4.76C10.6831 4.58667 10.8977 4.5 11.1537 4.5H12.8462C13.1022 4.5 13.3169 4.58667 13.4902 4.76C13.6634 4.93317 13.75 5.14783 13.75 5.404V18.596C13.75 18.8522 13.6634 19.0668 13.4902 19.24C13.3169 19.4133 13.1022 19.5 12.8462 19.5H11.1537ZM5.404 19.5C5.14783 19.5 4.93317 19.4133 4.76 19.24C4.58667 19.0668 4.5 18.8522 4.5 18.596V10.3122C4.5 10.0516 4.58667 9.835 4.76 9.6625C4.93317 9.49017 5.14783 9.404 5.404 9.404H7.09625C7.35225 9.404 7.56692 9.49058 7.74025 9.66375C7.91342 9.83692 8 10.0516 8 10.3078V18.5915C8 18.8523 7.91342 19.0689 7.74025 19.2413C7.56692 19.4138 7.35225 19.5 7.09625 19.5H5.404Z",
    fill: "#B6BCC8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyIbs);
export default __webpack_public_path__ + "static/media/icon_my_ibs.1a34218f46c37c72ec203c4306a76c06.svg";
export { ForwardRef as ReactComponent };